import React from 'react';
import {MasterLayout} from 'layout';
import { connect } from 'react-redux';
import { header } from 'constants/table';
import {TrangChu, ThongKeBaoCao} from 'api';
import moment from 'moment';
import DataTable from 'components/data-table';
import { RadioButton, Input, DatePicker, DropDown, DropDownMultipleSelect } from 'components/tt-forms/common';
import {
  DropDownChonLoaiDonThu,
  DropDownChonLinhVucDonThu,
  DropDownChonLinhVucDonThuChiTiet,
  DropDownChonNguonDon,
  DropDownKetQuaGiaiQuyet
} from 'components/tt-forms';
import RowItemKetQuaTraCuu from './RowItemKetQuaTraCuu.jsx';
import RowItemKetQuaTTCP from './RowItemKetQuaTTCP.jsx';
import { get } from 'lodash';
import classnames from 'classnames';

class CanBoTraCuu extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: '',
      phamVi: 'ALL',
      maDon: '',
      hoTen: '',
      diaChi: '',
      donViTiepNhanData: [],
      listDonViTiepNhan: [],
      listTinhTrangXuLy: [],
      phanLoaiDon: '',
      linhVucId: '',
      linhVucChiTietId: '',
      nguonDon:'',
      loading: false,
      data: [],
      soDinhDanhCaNhan: '',
      maTinh: '',
      maHuyen: '',
      maXa: '',
      noiDung: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      firstLoad: false,
      listLoaiTraCuu: [],
      loaiTraCuu: 'DON_THEO_QUY_TRINH',
      isDonCu: false,
      search: false
    }
  }

  getLoaiDonTraCuu() {
    ThongKeBaoCao.actions.getLoaiDonTraCuu.request().then(res => {
      if (res.data) {
        this.setState({listLoaiTraCuu: res.data});
      } else {
        this.setState({listLoaiTraCuu: []});
      }
    });
  }

  componentDidMount() {
    this.getTinhTrangTraCuu();
    this.getLoaiDonTraCuu();
    let arrData = [...this.state.donViTiepNhanData];
    this.props.dvTiepNhanList.map((item) => {
      return arrData = [...arrData, {value: item.coQuanQuanLyId, label: item.ten}];
    });
    let data = localStorage.getItem('tcData') ? JSON.parse(localStorage.getItem('tcData')) : {};
    this.state.donViTiepNhanData = arrData;
    this.state.pageData.number = data.page || 0;
    this.state.pageData.size = data.size || 10;
    this.state.phamVi = data.taiDonVi == 'TTCP' ? data.taiDonVi : (data.taiDonVi ? 'SCOPE' : 'ALL');
    this.state.maDon = data.maDon || data.maVuViec || '';
    this.state.hoTen = data.hoTen || data.tenNguoiKhieuNai || '';
    this.state.soDinhDanhCaNhan = data.soDinhDanhCaNhan || '';
    this.state.maTinh = data.maTinh || '';
    this.state.maHuyen = data.maHuyen || '';
    this.state.maXa = data.maXa || '';
    this.state.noiDung = data.noiDung || '';
    this.state.diaChi = data.diaChi || '';
    this.state.listDonViTiepNhan = data.listDVTN && data.listDVTN.length ? data.listDVTN : [];
    this.state.phanLoaiDon = data.phanLoaiDon || '';
    this.state.linhVucId = data.linhVucId || '';
    this.state.linhVucChiTietId = data.linhVucChiTietId || '';
    this.state.nguonDon = data.nguonDon || '';

    if (Object.keys(data).length > 1) {
      this.handleSearch();
    }
  }

  onChange(name, e) {
    if (name == 'phamVi') {
      this.setState({data: [], pageData: {number: 0, size: 10, totalElements: 0}, [name]: e.target.value});
    } else if (name == 'listDonViTiepNhan') {
      this.setState({listDonViTiepNhan: e});
    } else {
      if (name == 'phanLoaiDon') {
        this.setState({linhVucId: '', linhVucChiTietId: ''});
      }

      if (name == 'maTinh' || name == 'maHuyen') {
        this.state.maXa = '';
        if (name == 'maTinh') {
          this.state.maHuyen = '';
        }
      }
      this.setState({[name]: e.target.value});
    }
  }
  handleSearch(isFirst) {
    if (this.state.phamVi != 'TTCP') {
      if (isFirst) {
        this.state.pageData = {
          number: 0,
          size: 10,
          totalElements: 0
        };
      }
      let params = {
        taiDonVi: this.state.phamVi === 'SCOPE' ? true : false,
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        nguonDon: this.state.nguonDon || undefined,
        loaiDonTraCuu: this.state.loaiTraCuu || undefined,
        maDon: (this.state.maDon && this.state.maDon.trim()) || undefined,
        hoTen: (this.state.hoTen && this.state.hoTen.trim()) || undefined,
        diaChi: (this.state.diaChi && this.state.diaChi.trim()) || undefined,
        phanLoaiDon: this.state.phanLoaiDon || undefined,
        linhVucId: this.state.linhVucId || undefined,
        linhVucChiTietId: this.state.linhVucChiTietId || undefined
      };
      if (this.state.listDonViTiepNhan.length) {
        let strId = [];
        this.state.listDonViTiepNhan.map(item => {
          strId.push(item.value);
        });
        params.listDonViTiepNhan = strId.join();
      }
      this.setState({loading: true});
      localStorage.setItem('tcData', JSON.stringify(params));
      TrangChu.actions.getTraCuuDonCanBo.request(null, params).then(res => {
        if (res.data && res.data._embedded) {
          let newData = [];
          let isDonCu = false;
          if (this.state.loaiTraCuu === 'DON_CU_NHAP_LIEU') {
            newData = get(res, 'data._embedded.donCus');
            isDonCu = true;
          } else {
            newData = get(res, 'data._embedded.medial_DonTraCuus');
          }
          this.setState({
            data: newData,
            isDonCu
          });
        } else {
          this.setState({ data: [] });
        }
        this.setState({
          loading: false,
          pageData : res.data.page,
          firstLoad: true
        });
      }).catch(error => {
        this.setState({
          data : [],
          pageData : {
            number: 0,
            size: 10,
            totalElements: 0
          },
          firstLoad: true,
          loading: false
        });
      });
    } else {
      let params = {taiDonVi: this.state.phamVi};
      if (this.state.maDon) {
        params.maVuViec = this.state.maDon.trim();
      }
      if (this.state.hoTen) {
        params.tenNguoiKhieuNai = this.state.hoTen.trim();
      }
      if (this.state.soDinhDanhCaNhan) {
        params.soDinhDanhCaNhan = this.state.soDinhDanhCaNhan.trim();
      }
      if (this.state.noiDung) {
        params.noiDung = this.state.noiDung.trim();
      }
      if (this.state.maTinh) {
        params.maTinh = this.state.maTinh;
      }
      if (this.state.maHuyen) {
        params.maHuyen = this.state.maHuyen;
      }
      if (this.state.maXa) {
        params.maXa = this.state.maXa;
      }
      this.setState({loading: true, pageData: {number: 0, size: 10, totalElements: 0}});
      localStorage.setItem('tcData', JSON.stringify(params));
      TrangChu.actions.getTraCuuDonTTCP.request(null, params).then(res => {
        if (res.data) {
          this.setState({ data: res.data, loading: false, pageData: {number: 0, size: 10, totalElements: res.data.length}});
        } else {
          this.setState({ data: [], loading: false });
          this.setState({ loading: false });
        }
      }).catch(error => {
        this.setState({
          data: [],
          loading: false
        });
      });
    }
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.handleSearch();
  }

  handleChangePageSize(size) {
    this.state.pageData.number = 0;
    this.state.pageData.size = size;
    this.handleSearch();
  }
  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }
  getTinhTrangTraCuu() {
    TrangChu.actions.getTinhTrangTraCuuDon.request().then(res => {
      if (res.data) {
        this.setState({listTinhTrangXuLy: res.data});
      } else {
        this.setState({listTinhTrangXuLy: []});
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.dvTiepNhanList != this.props.dvTiepNhanList) {
      let arrData = [...this.state.donViTiepNhanData];
      nextProps.dvTiepNhanList.map((item) => {
        arrData = [...arrData, {value: item.coQuanQuanLyId, label: item.ten}];
      });
      this.setState({donViTiepNhanData: arrData});
    }
  }

  render() {
    let data = [
      {
        ten: 'Tra cứu trong đơn vị',
        giaTri: 'SCOPE'
      },
      {
        ten: 'Tra cứu toàn hệ thống',
        giaTri: 'ALL'
      }
      /* {
         ten: 'Tra cứu tại TTCP',
         giaTri: 'TTCP'
      } */
    ];
    const getHeader = () => {
      if (this.state.phamVi == 'TTCP') {
        return header.listTraCuuTTCP;
      }
      return this.state.isDonCu ? header.listTraCuuDonCu : header.listTraCuuDon;
    }
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="heading" style={{marginBottom: '0px'}}>
              <h2 className="heading-title icon-search" style={{display:'inline-block', marginRight: '40px'}}>Tra cứu đơn</h2>
              <div style={{display:'inline-block'}}>
                <RadioButton options={data}
                  selectedValue={this.state.phamVi}
                  keyName='giaTri'
                  valueName='ten'
                  onChange={this.onChange.bind(this, 'phamVi')} />
              </div>
            </div>
          </div>
          <div className="bottom-content">
            <form onSubmit={this.handleSearch.bind(this, true)} action="javascript:void(0)" noValidate>
              <div className="search-container super-search">
                <DropDown className='input-20' label="Loại tra cứu" options={this.state.listLoaiTraCuu} keyName="giaTri" valueName="ten" selectedValue={this.state.loaiTraCuu} placeholder={null} onChange={this.onChange.bind(this, 'loaiTraCuu')}/>
                <Input label="Mã đơn" name="maDon" placeholder="Nhập..." value={this.state.maDon} onChange={this.onChange.bind(this, 'maDon')} className="input-20" />
                <Input label="Tên người đứng đơn" name="hoTen" placeholder="Nhập..." value={this.state.hoTen} onChange={this.onChange.bind(this, 'hoTen')} className="input-20" maxLength={255} />
                {
                  this.state.phamVi == 'TTCP' &&
                    <Input label="Số CMND" name="scmnd" placeholder="Nhập..." value={this.state.soDinhDanhCaNhan} onChange={this.onChange.bind(this, 'soDinhDanhCaNhan')} className="input-20" />
                }
                {
                  this.state.phamVi != 'TTCP' &&
                    <Input label="Địa chỉ" placeholder="Nhập..." name="diaChi" value={this.state.diaChi} onChange={this.onChange.bind(this, 'diaChi')} className="input-20" />
                }
                <div className="btn-wrap-20">
                  <button
                    type="submit"
                    className={
                      classnames('pt-button btn-green tt-search', {
                        'btn-loading-inline': this.state.loading
                      })}>
                      <span>Xem kết quả</span>
                    </button>
                </div>
                {
                  this.state.phamVi == 'TTCP' &&
                  <div className="clear-left">
                    <Input label="Nội dung" name="noidung" placeholder="Nhập..." value={this.state.noiDung} onChange={this.onChange.bind(this, 'noiDung')} className="input-20" />
                  </div>
                }
                {
                  this.state.phamVi != 'TTCP' &&
                  <div className="clear-left">
                    <DropDownChonLoaiDonThu selectedValue={this.state.phanLoaiDon}  className="input-20" label="Loại đơn" onChange={this.onChange.bind(this, 'phanLoaiDon')} name="dropdownChonLoaiDonThu" isTraCuu={true}/>
                  </div>
                }
                {
                  this.state.phamVi != 'TTCP' &&
                    <DropDownChonLinhVucDonThu selectedValue={this.state.linhVucId} allowHidden={false} className="input-20" label="Lĩnh vực" loaiDonThuID={this.state.phanLoaiDon} onChange={this.onChange.bind(this, 'linhVucId')} name="dropdownChonLinhVucDonThu"/>
                }
                {
                  this.state.phamVi != 'TTCP' &&
                    <DropDownChonLinhVucDonThuChiTiet label="Lĩnh vực chi tiết (nếu có)" allowHidden={false} className="input-20" loaiDonThuID={this.state.phanLoaiDon} selectedValue={this.state.linhVucChiTietId} linhVucDonThuID={this.state.linhVucId} onChange={this.onChange.bind(this, 'linhVucChiTietId')} name="dropdownChonLinhVucCap2Id"/>
                }
                {
                  this.state.phamVi != 'TTCP' &&
                    <DropDownChonNguonDon
                      selectedValue={this.state.nguonDon}
                      onChange={this.onChange.bind(this, 'nguonDon')}
                      className="input-20"/>
                }
                {
                  this.state.phamVi == 'TTCP' &&
                  <Input label="Mã tỉnh" placeholder="Nhập..." name="maTinh" value={this.state.maTinh} onChange={this.onChange.bind(this, 'maTinh')} className="input-20" />
                }
                {
                  this.state.phamVi == 'TTCP' &&
                  <Input label="Mã huyện" placeholder="Nhập..." name="maHuyen" value={this.state.maHuyen} onChange={this.onChange.bind(this, 'maHuyen')} className="input-20" />
                }
                {
                  this.state.phamVi == 'TTCP' &&
                  <Input label="Mã xã" placeholder="Nhập..." name="maXa" value={this.state.maXa} onChange={this.onChange.bind(this, 'maXa')} className="input-20" />
                }
                {
                  this.state.phamVi != 'TTCP' && this.state.phamVi !== "SCOPE" &&
                    <DropDownMultipleSelect name="listDonViTiepNhan" className="input-20" label="Địa bàn (Đơn vị) tiếp nhận" options={this.state.donViTiepNhanData} placeholder={{key: '', text: '--Chọn--'}} value={this.state.listDonViTiepNhan} onChange={this.onChange.bind(this, 'listDonViTiepNhan')}/>
                }
              </div>
            </form>
            {
              this.state.data.length || this.state.firstLoad ?
                <DataTable header={getHeader()}
                  dataList={this.state.data}
                  hideButtonExport={true}
                  pageData={this.state.pageData}
                  parent={this}
                  displayCount={true}
                  search={this.state.search}
                  tableLoading={this.state.loading}>
                  {
                    this.state.phamVi == 'TTCP' ?
                      <RowItemKetQuaTTCP isDonCu={this.state.isDonCu}/>
                    :
                      <RowItemKetQuaTraCuu phamVi={this.state.phamVi} isDonCu={this.state.isDonCu}/>
                  }
                </DataTable>
              :''
            }
          </div>
        </div>
      </MasterLayout>
    );
  }
}
CanBoTraCuu.defaultProps = {
  dvTiepNhanList: []
}

function bindStateToProps(state) {
  return {
    dvTiepNhanList: state.duLieuHeThong.coQuanTiepNhan
  };
}

export default connect(bindStateToProps)(CanBoTraCuu);


// WEBPACK FOOTER //
// ./src/components/modules/tra-cuu/CanBoTraCuu.jsx